import { editorialSpread, aboutData } from '../../data/mock';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export const ShowcaseSection = () => {
  const [spreadRef, spreadVisible] = useScrollAnimation(0.1);
  const [aboutRef, aboutVisible] = useScrollAnimation(0.1);

  return (
    <>
      {/* Editorial Spread — Full-bleed featured project */}
      <section className="relative overflow-hidden">
        <div
          ref={spreadRef}
          style={{
            opacity: spreadVisible ? 1 : 0,
            transition: 'opacity 1.2s ease',
          }}
        >
          <div className="relative aspect-[21/9] min-h-[400px]">
            <img
              src={editorialSpread.image}
              alt={editorialSpread.title}
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/60 via-[#0A0A0A]/15 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/50 via-transparent to-transparent" />

            <div className="absolute bottom-0 left-0 p-8 md:p-12 lg:p-16 max-w-xl">
              <p className="text-[#C4A265] tracking-[0.35em] uppercase text-[10px] mb-2">
                Featured — {editorialSpread.credit}
              </p>
              <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-[#F5F1EC] italic mb-3 leading-[0.95]">
                {editorialSpread.title}
              </h2>
              <p className="text-[#8A8580] text-[11px] tracking-[0.15em] uppercase mb-4">
                Architect: {editorialSpread.architect}
              </p>
              <p className="text-[#9A9590] text-sm leading-relaxed hidden md:block">
                {editorialSpread.caption}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About — Minimal, lookbook-style */}
      <section id="about" className="bg-[#0A0A0A] py-20 lg:py-28">
        <div
          ref={aboutRef}
          className={`max-w-[1600px] mx-auto px-6 lg:px-16 transition-all duration-700 ${
            aboutVisible
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-6 items-start">
            {/* Left — Quote & Text */}
            <div className="lg:col-span-5 lg:pr-8">
              <p className="text-[#C4A265] tracking-[0.4em] uppercase text-[11px] mb-6">
                Since 1994
              </p>
              <blockquote className="font-serif text-2xl md:text-3xl text-[#F5F1EC] italic leading-snug mb-8">
                &ldquo;{aboutData.quote}&rdquo;
              </blockquote>
              <div className="w-10 h-[1px] bg-[#C4A265]/30 mb-8" />
              <p className="text-[#8A8580] text-sm leading-[1.8]">
                {aboutData.body}
              </p>
            </div>

            {/* Right — Image collage */}
            <div className="lg:col-span-7 grid grid-cols-5 gap-3">
              <div className="col-span-3 overflow-hidden">
                <img
                  src={aboutData.showroomImage}
                  alt="Showroom"
                  loading="lazy"
                  className="w-full h-[320px] lg:h-[440px] object-cover hover:scale-[1.03] transition-transform duration-700"
                />
              </div>
              <div className="col-span-2 flex flex-col gap-3">
                <div className="overflow-hidden flex-1">
                  <img
                    src={aboutData.founderImage}
                    alt="Founders"
                    loading="lazy"
                    className="w-full h-full object-cover hover:scale-[1.03] transition-transform duration-700"
                  />
                </div>
                <div className="overflow-hidden flex-1">
                  <img
                    src={aboutData.detailImage}
                    alt="Hardware detail"
                    loading="lazy"
                    className="w-full h-full object-cover hover:scale-[1.03] transition-transform duration-700"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
